import lenis from "./lenis.js";

export function downArrowScript() {

    const downArrow = document.querySelector('.scroll-down__icon');
    const banner = document.querySelector('.banner');

    if (downArrow && banner) {
        downArrow.addEventListener('click', (e) => {
            e.preventDefault();

            // Position where the banner ends
            const bannerBottom = banner.offsetTop + banner.offsetHeight;

            lenis().scrollTo(bannerBottom, {
                duration: .7,
                easing: (t) => 1 - Math.pow(1 - t, 3), // easeOutCubic
            });
        });
    }
}